import { render } from "./VideoBackground.vue?vue&type=template&id=60649c28&scoped=true"
import script from "./VideoBackground.vue?vue&type=script&lang=js"
export * from "./VideoBackground.vue?vue&type=script&lang=js"

import "./VideoBackground.vue?vue&type=style&index=0&id=60649c28&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src771272295/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60649c28"]])

export default __exports__